import { GET_USER_DATA_QUERY } from '../graphql-client/queries';

const resolvers = {
  Mutation: {
    activeArtist: (_info, _args, { cache }) => {
      const data = {
        activeArtist: {
          _id: _args._id,
          artistImage: _args.artistImage,
          name: _args.name,
          email: _args.email,
          isDefault: _args.isDefault,
          __typename: 'activeArtist',
        },
      };
      cache.writeData({ data });
    },
    setNotification: (_info, _args, { cache }) => {
      const data = {
        notification: {
          notification: _args.notification,
          emailNotification: _args.emailNotification,
          __typename: 'notification',
        },
      };
      cache.writeData({ data });
    },

    unseenMessages: (_info, _args, { cache }) => {
      const data = {
        unseenMessages: _args.unseenMessages.map((el) => ({ ...el, ...{ __typename: 'unseenMessagesList', _id: Math.random() } })),
        __typename: 'unseenMessages',
      };
      cache.writeData({ data });
    },
  },

  Query: {
    getUser: (_info, _args, { client }) => {
      client.writeQuery({
        query: GET_USER_DATA_QUERY,
        data: { isLoginOpen: false },
      });
    },
  },
};

const defaults = {
  getUser: {
    __typename: 'getUser',
  },
};

export default { resolvers, defaults };
